export enum IconType {
  Bus,
  Check,
  CheckIn,
  Cleaning,
  Coffee,
  Food,
  House,
  Info,
  Other,
  People,
  Ride,
  Split,
  Stop,
  Reserve,
  Unknown,
  Wait,
  Walk,
  Warning,
  LocalGasStation,
  Group,
  HourglassEmpty

}
